import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "Your existing passwords/IDs and/or settings are encrypted and stored in the memory of the smart lock even in the absence of power supply. Once the depleted batteries have been replaced with new ones or external USB power source is inserted at the USB connector, your smart lock should work as per normal.",
    back: "Back",
  },
  ja: {
    reply1:
      "既存のパスワード/ID および/または設定は暗号化され、電源がない場合でもスマート ロックのメモリに保存されます。消耗した電池を新しい電池と交換するか、外部 USB 電源を USB コネクタに挿入すると、スマート ロックは通常どおりに動作するはずです。",
    back: "戻る",
  },
  es: {
    reply1:
      "Sus contraseñas/ID y/o configuraciones existentes se cifran y almacenan en la memoria de la candado inteligente incluso en ausencia de suministro de energía. Una vez que las baterías agotadas se hayan reemplazado por otras nuevas o se haya insertado una fuente de alimentación USB externa en el conector USB, su candado inteligente debería funcionar normalmente.",
    back: "Atrás",
  },
});

class Q8_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q8_component;
